import { withTranslation } from 'react-i18next';
// import * as utils from "../../global/utils";
import * as Helpers from "../../global/Helpers";
import CustomReactComponent from "../shared/CustomReactComponent/CustomReactComponent";

// import * as Constants from "../../constants/Constants";

// import * as AppUrls from "../../constants/AppUrls";
import { Redirect } from "react-router";
import IFrameComponent from "../IFrameComponent/IFrameComponent";


import React from 'react';
// import { useTranslation } from "react-i18next";

import SubComponent from "./SubComponent"
import "./TermsAndConditions.css"

import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import * as utils from "../../global/utils";
import * as Constants from "../../constants/Constants"
class TermsAndConditions extends CustomReactComponent {
    constructor(props) {
        super(props);
    }
    state = {
        iframeSrc: "",
        redirect: null,
        TermsAndConditionsText: ""       
    }

    componentDidMount() {
     
        var DeviceConfigs = JSON.parse(localStorage.getItem("DeviceConfigs"));
        if (DeviceConfigs !== null && DeviceConfigs !== undefined) {
            var url = this.props.i18n.language === "ar" ? DeviceConfigs.TermsAndConditionsAR : DeviceConfigs.TermsAndConditions
            let theme = localStorage.getItem("theme");
            if (theme === null || theme === undefined) { theme = "light"; }
            var TermsAndConditionsURL = url + "fitapp=etrade-" + theme
            this.setState({ iframeSrc: TermsAndConditionsURL })
        }

        
        // const box = document.getElementsByClassName('login_logo')[0];
        // box.style.visibility = 'hidden';
        
        // const boxTitle = document.getElementsByClassName('LoginTitle')[0];
        // if(boxTitle !== undefined && boxTitle !== null)
        // boxTitle.style.visibility = 'hidden';


        // const boxMsg = document.getElementsByClassName('WelcomeMessageDiv')[0];
        // if(boxMsg !== undefined && boxMsg !== null)
        // boxMsg.style.visibility = 'hidden';

        // const boxLogin = document.getElementsByClassName('LoginFormContainer')[0];
        // if(boxLogin !== undefined && boxLogin !== null){
        //     boxLogin.style.background = 'none';
        //     boxLogin.style.boxShadow = 'none';
        //     boxLogin.style.border = 'none';

        // }
            // 
            // if(localStorage.getItem(Constants.localStorageConstants.company_name).toUpperCase() === "IFS"){
            // const AuthCont = document.getElementsByClassName('form-horizantal')[0];
            // if(AuthCont !== undefined && AuthCont !== null){
            // AuthCont.style.width = '100%';


            // }
            // }  


       
        this.GetTermsAndConditionsText(this.props.i18n.language);
    }  

    // componentDidUpdate(prevProps) {
    //     if (prevProps.i18n.language !== this.props.i18n.language) {
            
    //         this.GetTermsAndConditionsText(this.props.i18n.language);
    //       }
    // }
    
    

    GetTermsAndConditionsText = (appLang) => {
        let GetTermsAndConditionsTextResponse = utils.GetTermsAndConditionsText(appLang);
        GetTermsAndConditionsTextResponse
            .then((response) => response.data)
            .then((data) => {
                
                //console.log("GetTermsAndConditionsTextResponse", data)                
                this.setState({ TermsAndConditionsText: data })
            })
            .catch((error) => {
                console.log(error);
            });
    };


     

    
    render() {
        let leftLocalized = "left";
        let direction = "ltr";
        let marginInline = "2px";
        if (this.props.i18n.language === "ar") {
            direction = "rtl";
            marginInline = "21px";
            leftLocalized = "right";
        }
        if (this.state.redirect !== null) {
            return <Redirect to={this.state.redirect} />;
        }

        return (
        
            <div className={"custom-popup custom-scrollable TermsAndConditions-popup       " + Helpers.getAppTheme()} >
                <div
                    className="custom-popup-header pt-2"
                    style={{
                        display: "flex",
                        flexDirection: this.props.i18n.language === "ar" ? "row-reverse" : "unset"
                    }}
                >
                    <div style={{ fontSize: "14px" , width: "100%" , textAlign: "initial" , marginInline: marginInline }} >
                        <strong className="lableCustomized">

                            {this.props.t("TermsAndConditions")}
                        </strong>
                    </div>
                    <div

                    >

                    </div>
                </div>
                <div
                    className="custom-popup-body pt-2 pb-2 display-vertically"
                    style={{
                        height: "calc(100% - 45px)",
                        overflowY: "auto",
                        direction: direction,
                        textAlign: leftLocalized
                    }}
                >
                    {
                    localStorage.getItem(Constants.localStorageConstants.company_name).toUpperCase() === "IFS" ? 
                    <IFrameComponent iframeSrc={this.state.iframeSrc} />:  <div dangerouslySetInnerHTML={{ __html: this.state.TermsAndConditionsText }} /> 
                    }   

                    <SubComponent onClose={this.props.onClose} callLogOff={this.props.callLogOff}/>

                    
                </div>
            </div>
        );
    }
}


export default (withTranslation()(TermsAndConditions)) ;


// const IFrameComponent2 = (props) => {

//     const { i18n } = useTranslation();

//     const [iframeSrc, setIframeSrc] = useState("");
//     const [redirect, setRedirect] = useState(null);
//     const [disabledButton, setisDisabledButton] = useState(true);
//     const [checkedDetail, setCheckedDetail] = useState(false);

//     useEffect(() => {

//         /* componentDidMount */
// 
//         var DeviceConfigs = JSON.parse(localStorage.getItem("DeviceConfigs"));
//         if (DeviceConfigs !== null && DeviceConfigs !== undefined) {
//             var url = i18n.language === "ar" ? DeviceConfigs.TermsAndConditionsAR : DeviceConfigs.TermsAndConditions
//             let theme = localStorage.getItem("theme");
//             if (theme === null || theme === undefined) { theme = "light"; }
//             var TermsAndConditionsURL = url + "fitapp=etrade-" + theme


//             setIframeSrc(TermsAndConditionsURL);

//         }

//     }, [])


//     function callLogOff() {

//         let logOffResponse = utils.logOff();
//         logOffResponse
//             .then((response) => {
//                 
//                 //console.log("Logged Off", response)
//                 if (response.status === 200) {
//                     localStorage.removeItem("user");
//                     localStorage.removeItem("ExpiredDocument");
//                     let UserName = localStorage.getItem("username");
//                     let RememberMe = localStorage.getItem("isRememberMe");
//                     let language = localStorage.getItem("language");
//                     let Comapnyname = localStorage.getItem(
//                         Constants.localStorageConstants.company_name
//                     );
//                     var prev = Helpers.getPreviousConfig();

//                     localStorage.clear();
//                     localStorage.setItem("language", language);
//                     localStorage.setItem(Constants.localStorageConstants.company_name, Comapnyname);

//                     Helpers.SetpreviosConfig(prev);
//                     disconnectSignalr();
//                     setRedirect(AppUrls.login);


//                 }
//             })
//             .catch((error) => {
//                 //this.props.setIsLoaderVisible(false);
//                 console.log("errorcallLogOff", error);
//             });
//     };

//     function disconnectSignalr() {
//         
//         if (
//             props.signalr_connection !== undefined &&
//             props.signalr_connection !== null &&
//             props.signalr_connection.state === 1
//         ) {
//             props.signalr_connection.proxies.myhub.invoke("Disconnected");
//         }
//         if (
//             props.signalr_connection !== undefined &&
//             props.signalr_connection !== null
//         ) {
//             props.signalr_connection.stop();
//             Helpers.emptyCache();
//         }
//     };

//     let leftLocalized = "left";
//     let direction = "ltr";
//     if (i18n.language === "ar") {
//         direction = "rtl";
//     }
//     if (redirect !== null) {
//         return <Redirect to={redirect} />;
//     }
//     return (
//         <div className={"custom-popup custom-scrollable TermsAndConditions-popup " + Helpers.getAppTheme()} style={{ height: "600px", width: "600px" }} >
//             <div
//                 className="custom-popup-header pt-2"
//                 style={{
//                     display: "flex",
//                     flexDirection: i18n.language === "ar" ? "row-reverse" : "unset"
//                 }}
//             >
//                 <div style={{ fontSize: "14px" }} >
//                     <strong className="lableCustomized">

//                         {i18n.t("TermsAndConditions")}
//                     </strong>
//                 </div>
//                 <div

//                 >

//                 </div>
//             </div>
//             <div
//                 className="custom-popup-body pt-2 pb-2 display-vertically"
//                 style={{
//                     height: "calc(100% - 45px)",
//                     overflowY: "auto",
//                     direction: direction,
//                     textAlign: leftLocalized
//                 }}
//             >

//                 <IFrameComponent iframeSrc={iframeSrc} />
//                 {/* <iframe
//                     key={Math.random()}
//                     src={this.state.iframeSrc}

//                     style={{ width: "100%", height: "480px" }}
//                 >
//                 </iframe> */}

//                 <div style={{ display: "flex" }}>
//                     <input type="checkbox"
//                         name="checkedDetail"
//                         checked={checkedDetail}
//                         onClick={(checked) => {
//                             
//                             var disable = true;
//                             if (checked.target.checked) {
//                                 disable = false
//                             }
//                             setCheckedDetail(checked.target.checked);
//                             setisDisabledButton(disable);

                           
//                         }}>

//                     </input>
//                     <p>{i18n.t("CheckboxTextTermsAndConditions")}</p>
//                 </div>

//                 <div className="custom-popup-body pt-2 pb-2" >

//                     <button
//                         className="btn custom-btn-primary"
//                         style={{ width: "30%", maxWidth: "100px", borderRadius: "10px" }}
//                         onClick={(e) => {
//                             setRedirect(AppUrls.trading);

//                         }}
//                         disabled={disabledButton}
//                     >
//                         {i18n.t("IAgree")}
//                     </button>

//                     <button
//                         className="btn custom-btn-primary"
//                         style={{ width: "30%", maxWidth: "100px", borderRadius: "10px" }}
//                         onClick={callLogOff}
//                         disabled={disabledButton}
//                     >
//                         {i18n.t("signout")}
//                     </button>
//                 </div>
//             </div>
//         </div>





//     );
// }
// const mapStateToProps = (state) => {
//     return {

//         signalr_connection: state.signalr_connection,

//     };
// };

// export default connect(mapStateToProps, null)(withTranslation()(IFrameComponent2));






